let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

// ----------------hide fitment on pdp in product card if it's no data--------------
  const observer = new MutationObserver(() => {
    const fitmentContainer = document.querySelector("#cm-verify-fitment");
    const fitmentTitle = fitmentContainer?.querySelector(".cm_verify-fitment_title");

    if (fitmentTitle && fitmentTitle.textContent.trim() === "No Fitment Data") {
      fitmentContainer.style.display = "none";
      observer.disconnect(); // Stop observing once condition is met
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

// ---------------------------
